import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchLegacyRoutes = createAsyncThunk('legacyRoutes/fetchLegacyRoutes', async (params, { rejectWithValue }) => {
  try { const res = await service.getLegacyRoutes(params); return { params, data: res.data, meta: res.meta } } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const fetchLegacyRoute = createAsyncThunk('legacyRoutes/fetchLegacyRoute', async (id, { rejectWithValue }) => {
  try { return await service.getLegacyRoute(id) } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const addLegacyRoute = createAsyncThunk('legacyRoutes/addLegacyRoute', async (payload, { rejectWithValue }) => {
  try { return await service.addLegacyRoute(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const saveLegacyRoute = createAsyncThunk('legacyRoutes/saveLegacyRoute', async (payload, { rejectWithValue }) => {
  try { return await service.updateLegacyRoute(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const removeLegacyRoute = createAsyncThunk('legacyRoutes/removeLegacyRoute', async (id, { rejectWithValue }) => {
  try { await service.deleteLegacyRoute(id); return id } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const uploadLegacyRoutes = createAsyncThunk('legacyRoutes/uploadLegacyRoutes', async (file, { rejectWithValue }) => {
  try { return await service.uploadLegacyRoutes(file) } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

export const confirmUpload = createAsyncThunk('legacyRoutes/confirmUpload', async (payload, { rejectWithValue }) => {
  try { return await service.confirmLegacyRoutesUpload(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})

const slice = createSlice({
  name: 'legacyRoutes',
  initialState: {
    data: [],
    meta: null,
    params: {
      page: 1,
      take: 10,
      order: 'ASC',
      q: '',
      status: '',
      reviewStatus: ''
    },
    selected: null,
    loading: false,
    error: null,
    uploadPreview: null,
    uploadLoading: false,
    uploadError: null
  },
  reducers: {
    setLegacyRouteParams(state, action) { state.params = action.payload },
    clearUploadPreview(state) { state.uploadPreview = null; state.uploadError = null }
  },
  extraReducers: b => {
    b.addCase(fetchLegacyRoutes.pending, s => { s.loading = true })
     .addCase(fetchLegacyRoutes.fulfilled, (s, a) => { s.loading = false; s.data = a.payload.data; s.meta = a.payload.meta; s.params = a.payload.params })
     .addCase(fetchLegacyRoutes.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(fetchLegacyRoute.pending, s => { s.loading = true })
     .addCase(fetchLegacyRoute.fulfilled, (s, a) => { s.loading = false; s.selected = a.payload })
     .addCase(fetchLegacyRoute.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(addLegacyRoute.fulfilled, (s, a) => { s.data.unshift(a.payload) })
     .addCase(saveLegacyRoute.fulfilled, (s, a) => { const i = s.data.findIndex(x => x.id === a.payload.id); if (i > -1) s.data[i] = a.payload })
     .addCase(removeLegacyRoute.fulfilled, (s, a) => { s.data = s.data.filter(x => x.id !== a.payload) })
     .addCase(uploadLegacyRoutes.pending, s => { s.uploadLoading = true; s.uploadError = null })
     .addCase(uploadLegacyRoutes.fulfilled, (s, a) => { s.uploadLoading = false; s.uploadPreview = a.payload })
     .addCase(uploadLegacyRoutes.rejected, (s, a) => { s.uploadLoading = false; s.uploadError = a.payload })
     .addCase(confirmUpload.pending, s => { s.uploadLoading = true })
     .addCase(confirmUpload.fulfilled, (s) => { s.uploadLoading = false; s.uploadPreview = null })
     .addCase(confirmUpload.rejected, (s, a) => { s.uploadLoading = false; s.uploadError = a.payload })
  }
})

export const { setLegacyRouteParams, clearUploadPreview } = slice.actions
export default slice.reducer
